import { createApi } from '@reduxjs/toolkit/query/react';
import AppEnvironment from '../../environment/app-environment';
import { selexpApiBaseQuery } from './selexp-api-base-query';

export const selexpComplianceApiDuck = createApi({
  reducerPath: 'APISelexpCompliance',
  baseQuery: (args, api, extraOptions) => selexpApiBaseQuery(args, { ...api, endpoint: AppEnvironment.selexpComplianceEndpoint! }, extraOptions),
  endpoints: () => ({}),
  keepUnusedDataFor: 60, // 1 min. When a seller signs a PPA, it happens through Adobe portal. The UI does not know that it is signed.
  // So when a seller comes back to Complinance Page, we want to show the latest data after sigining. We do not want the cached response.
  // So decreasing the time from standard 1 hour to 1 min.
});
